module.exports = "/_next/static/images/pricing-plans-consulting-service-3-715552a0a8cd45d6da8344ddedb3f783.webp";